function getMonthList(locales, format) {
  const year = new Date().getFullYear();
  const monthList = [...Array(12).keys()]; // [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]
  const formatter = new Intl.DateTimeFormat(locales, {
    month: format
  });

  const getMonthName = (monthIndex) => {
    let monthName = formatter.format(new Date(year, monthIndex));
    
    // Remove trailing period if it exists
    if (monthName.endsWith('.')) {
      monthName = monthName.slice(0, -1);
    }
    
    // Capitalize the first letter
    return monthName.charAt(0).toUpperCase() + monthName.slice(1);
  };

  return monthList.map(getMonthName);
}

class ShippingCalculator {
  constructor() {
    this.init();
  }

  get shippingConfigEl() {
    return document.querySelector('[data-shipping-config]');
  }
  get wrapperEl() {
    if (this.shippingConfigEl) return this.shippingConfigEl.closest('[data-estimate-wrapper]');
  }

  get config() {
    if (this.shippingConfigEl) return JSON.parse(this.shippingConfigEl.dataset.shippingConfig);
  }

  async init() {
    await this.replaceTime();
    await this.replaceDates();
    if (this.wrapperEl) this.wrapperEl.classList.remove('loading-animate');
  }

  async getDates() {
    if (!this.config) {
      if (this.shippingConfigEl) this.shippingConfigEl.classList.add('!hidden');
      return;
    }
    const { allowedWeekdays, minShippingDays, maxShippingDays } = this.config;

    const today = new Date();
    let startDate, endDate, monthNames;

    monthNames = getMonthList(Shopify.locale,'short');

    for (let i = minShippingDays; i <= maxShippingDays; i++) {
      const date = new Date();
      date.setDate(today.getDate() + i);

      if (allowedWeekdays.includes(date.getDay())) {
        if (!startDate) {
          startDate = date;
        }
        endDate = date;
      }
    }

    if (!startDate || !endDate) return '';

    const startDateStr = `${startDate.getDate()} ${monthNames[startDate.getMonth()]}`;
    const endDateStr = `${endDate.getDate()} ${monthNames[endDate.getMonth()]}`;

    return startDate === endDate ? `${startDateStr}` : `${startDateStr} - ${endDateStr}`;
  }

  async replaceTime() {
    if (!this.config) return;
    let shippingTime = this.config.dailyShippingTime;
    if (!shippingTime) return;

    shippingTime = shippingTime.toString().concat(':00');
    this.shippingConfigEl.innerHTML = this.shippingConfigEl.innerHTML.replace(/{TIME}/g, shippingTime);
  }

  async replaceDates() {
    if (!this.config) return;
    const shippingDates = await this.getDates();
    if (!shippingDates) return;

    this.shippingConfigEl.innerHTML = this.shippingConfigEl.innerHTML.replace(/{DATE}/g, shippingDates);
  }
}

new ShippingCalculator();
